import { action } from '@ember/object';
import { easeInAndOut } from 'ember-animated/easings/cosine';
import { fadeIn, fadeOut } from 'ember-animated/motions/opacity';
import { inject as service } from '@ember/service';
import { parallel } from 'ember-animated';
import { task, rawTimeout } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { wait } from 'ember-animated';
import Component from '@glimmer/component';
import move from 'ember-animated/motions/move';
import { next } from '@ember/runloop';
import normalizeIdentifier from 'ember-stereo/-private/utils/normalize-identifier';

export default class SystemComponent extends Component {
  @service store;
  @service settings;
  @service stereo;
  @service feeds;
  @service metrics;
  @service playback;

  @tracked page = 'player';
  @tracked sizing = {};
  @tracked dimensions = {};

  @action
  onModeSwitch(value) {
    if (value == 'playback') {
      if (this.feeds.currentPlayback) {
        this.page = 'playback';
        this.feeds.selectFeed(this.feeds.currentPlayback);

        if (!this.feeds.currentPlayback.loadedSound?.isPlaying) {
          this.feeds.currentPlayback.playTask.perform()
        }
      } else {
        this.page = 'schedule';
      }
    } else if (value == 'live') {
      this.page = 'live';
      this.feeds.selectFeed(this.feeds.currentBroadcast);
      if (!this.feeds.currentBroadcast.loadedSound?.isPlaying) {
        this.feeds.currentBroadcast.playTask.perform()
      }
    } else {
      this.page = 'schedule';
    }
  }

  get selectedFeed() {
    return (
      this.feeds.current ||
      this.feeds.currentBroadcast
    );
  }

  get selectedNavigationItem() {
    if (this.page == 'schedule') {
      return 'schedule';
    } else if (this.selectedFeed == this.feeds.currentBroadcast) {
      return 'live';
    } else if  (this.selectedFeed == this.feeds.currentPlayback) {
      return 'playback';
    }
  }

  get normalizedIdentifier() {
    if (this.args.identifier !== '') {
      return normalizeIdentifier(this.args.identifier);
    } else {
      return this.args.identifier;
    }
  }

  @action
  onPlayerSizeChange({ queryResults, dimensions }) {
    next(() => {
      this.playerSizing = queryResults;
      this.playerDimensions = dimensions;
    });
  }

  @action
  onContainerSizeChange({ queryResults, dimensions }) {
    next(() => {
      this.sizing = queryResults;
      this.dimensions = dimensions;
    });
  }

  @tracked showTopPlayer = false;

  @action
  onVisibilityChange(visibility) {
    this.showTopPlayer = !visibility;
  }

  autoPlayTask = task({ restartable: true, maxConcurrency: 1 }, async () => {
    while (!this.settings.isLoaded) {
      await rawTimeout(10);
    }
    while (!this.feeds.currentBroadcast) {
      await rawTimeout(10);
    }

    if (this.args.autoplay) {
      this.stereo.playTask.perform(this.feeds.currentBroadcast.url);
    } else {
      this.stereo.loadTask.perform(this.feeds.currentBroadcast.url);
    }
  });

  @action
  didInsert() {
    this.metrics.trackPage({ url: window.location.href, title: "Deluxe Player" });
  }
}
